import React from "react";
import {
  getTopicId,
  getTopicOptionLabel,
  hasTopicAccessMetadata,
  isTopicSelectable,
} from "./oralTopicAccess";

export const ORAL_TOPIC_ACCESS_NOTE =
  "Topics marked Free Trial can be used with promotional credits. Topics marked Paid Access require sufficient paid credits or an active subscription.";

export default function OralTopicSelect({
  topics,
  value,
  onChange,
  disabled,
  style,
}) {
  return (
    <>
      <select
        style={style}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
      >
        {topics.map((topic) => (
          <option
            key={getTopicId(topic)}
            value={getTopicId(topic)}
            disabled={!isTopicSelectable(topic)}
          >
            {getTopicOptionLabel(topic)}
          </option>
        ))}
      </select>
      {hasTopicAccessMetadata(topics) ? (
        <div
          style={{
            marginTop: 6,
            color: "#6b7280",
            fontSize: 13,
            lineHeight: 1.45,
          }}
        >
          {ORAL_TOPIC_ACCESS_NOTE}
        </div>
      ) : null}
    </>
  );
}
